/**
 * Created by enixjin on 12/20/16.
 */

export {centralizedPostgreSQL} from "./centralizedPostgreSQL";